import Axios from 'axios';

export default Axios.create({
  baseURL: 'http://localhost:8080/api',
  // baseURL: 'https://elocotacao.com.br:8443/coto/api',
  withCredentials: true,
});
